import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";
const getRoleModules = async (params) => {
  const data = await apiCall("get", apiEndPoints.GETROLEMODULES);
  return data;
};
const getModuleList = async (params) => {
  const data = await apiCall("post", apiEndPoints.GETMODULESLIST, params);
  return data;
};
const createModule = async (params) => {
  const data = await apiCall("post", apiEndPoints.CREATEMODULE, params);
  return data;
};

const moduleService = {
  getRoleModules,
  getModuleList,
  createModule,
};

export default moduleService;
